import { tagCommanderReload, tagCommanderSetVariables } from '@declaration/helpers/tagCommander';
import { CONFIG } from '@shared/environment/environment';
import { INSURER_CONFIG } from '@shared/insurer';
import { handleMaintenance } from '@declaration/services/handleMaintenance';
async function routerMiddleware(context) {
    var _a;
    await context.store.dispatch('settings/fetchSettingsIfNotSet');
    if (!context.store.getters['settings/areSettingsFetched']) {
        handleMaintenance(context.store);
        return;
    }
    const selfCareSettings = context.store.getters['settings/setting']('selfCareSettings');
    const allowLogin = INSURER_CONFIG.declaration.allowLogin.includes(CONFIG.environment);
    // On se base sur le nom de la route (sans le suffixe de langue ajouté par nuxt-i18n)
    // et non sur l'URL, pour bloquer aussi les langues préfixées (toutes sauf la defaultLocale, ex. /en/login).
    if (context.getRouteBaseName(context.route) === 'login' && !allowLogin) {
        return context.redirect(context.localePath('access-forbidden'));
    }
    if (((_a = context.route.meta) === null || _a === void 0 ? void 0 : _a.length) && context.route.meta[0].tcVars) {
        tagCommanderSetVariables(context.route.meta[0].tcVars, selfCareSettings);
        tagCommanderReload(selfCareSettings);
    }
}
export default routerMiddleware;
